import(/* webpackMode: "eager", webpackExports: ["PoolChartClient"] */ "/app/app/pools/[protocol]/[pair]/PoolChartClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/pools/[protocol]/[pair]/PoolPageClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/pools/[protocol]/[pair]/pools.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ChartComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
